/* eslint-disable @typescript-eslint/member-ordering */
import { ChangeDetectionStrategy, Component, inject, input, InputSignal, output, OutputEmitterRef, signal, Signal } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent, SideSheetDirective, SideSheetHeaderComponent, SplitButtonComponent } from '@libs/common/components';
import { IconComponent } from '@libs/components/icons';
import { CapacitorService } from '@libs/shared/common';
import { IconName, SCANNER_ROUTE_NAME } from '@libs/shared/models';
import { CartScannerHandlerService } from '@libs/shared/services';

@Component({
  selector: 'ui-order-bottom-bar',
  imports: [
    ButtonComponent,
    IconComponent,
    SideSheetDirective,
    SideSheetHeaderComponent,
    SplitButtonComponent,
  ],
  templateUrl: './order-bottom-bar.component.html',
  styleUrl: './order-bottom-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderBottomBarComponent {
  private readonly router: Router = inject(Router);
  private readonly capacitorService: CapacitorService = inject(CapacitorService);

  public mainButtonLabel: InputSignal<string> = input.required();
  public sideSheetLabel: InputSignal<string> = input.required();
  public splitButtonIcon: InputSignal<IconName> = input<IconName>('circle-info');

  public isLoading: InputSignal<boolean> = input(false);
  public disabled: InputSignal<boolean> = input(false);

  public mainButtonIsSplit: InputSignal<boolean> = input(false)

  public mainClicked: OutputEmitterRef<void> = output();
  public secondaryClicked: OutputEmitterRef<void> = output();
  public isCapacitorApp: Signal<boolean> = signal(this.capacitorService.isCapacitorApp());

  public openBarcodeScanner(): Promise<boolean> {
    return this.router.navigate([SCANNER_ROUTE_NAME, CartScannerHandlerService.Key, '']);
  }
}
